import Reveal from "@/components/escape21/Reveal";
import CtaWhats from "./CtaWhats";

const FinalCta = () => (
  <section className="bg-gradient-to-b from-black to-green-950/30 px-6 py-24 sm:py-32">
    <div className="mx-auto max-w-2xl text-center">
      <Reveal>
        <h2 className="text-3xl font-extrabold leading-tight tracking-[-0.03em] sm:text-5xl">
          bora criar <span className="e21-serif text-green-400">impacto</span> junto.
        </h2>
        <p className="mx-auto mt-6 max-w-lg text-lg text-white/70">
          tua marca merece estar onde as pessoas realmente prestam atenção. me chama
          e a gente monta a parceria.
        </p>
        <div className="mt-10">
          <CtaWhats label="vamos conversar no whatsapp" className="px-10 py-5 text-lg" />
        </div>
      </Reveal>
    </div>
  </section>
);

export default FinalCta;
